module.exports = __webpack_public_path__ + "img/icon_primary_menu_inventory@2x.9f2161a2.png";